<template>
  <div>
    <router-view />
  </div>
</template>
<script>
import { isJSONString } from "@/utils/utils";
import { hasYjbParameter } from "@/utils/intConfiguration"
export default {
  data() {
    return {
      dictionary: [
        {
          hostname: 'diting',
          title: '集团风控策略平台',
          ico: 'favicon',
        },
        {
          hostname: 'paladin',
          title: '平台客户管理系统',
          ico: 'favicon',
        },
        {
          hostname: 'gyl',
          title: '供应链平台',
          ico: 'znlh',
        },
        {
          hostname: 'boss',
          title: 'BOSS后台管理系统',
          ico: 'favicon',
        },
        {
          hostname: 'farm',
          title: '息壤-集团信息化平台',
          ico: 'xirang_favicon',
        },
        {
          hostname: 'xirang',
          title: '息壤-集团信息化平台',
          ico: 'xirang_favicon',
        },
        {
          hostname: 'crm',
          title: '商端CRM',
          ico: 'favicon',
        },
        {
          hostname: 'sh',
          title: '众能联合商户版',
          ico: 'znlh',
        },
        {
          hostname: 'skydome',
          title: hasYjbParameter() ? '易机帮-项目用车管理平台' : '众能联合企业版-工程项目设备管理SaaS系统',
          ico: 'znlh',
        },
        {
          hostname: 'ccs',
          title: '集团线索平台',
          ico: 'favicon',
        },
        {
          hostname: 'finance',
          title: '财务工作台',
          ico: 'favicon',
        },
        {
          hostname: 'themis',
          title: '律师端',
          ico: 'favicon',
        },
        {
          hostname: 'logistics',
          title: '物流管理系统',
          ico: 'znlh',
        },
        {
          hostname: 'tboss',
          title: '供应链平台',
          ico: 'znlh',
        },
        {
          hostname: 'tms',
          title: '供应链平台物流',
          ico: 'znlh',
        },
        {
          hostname: 'bigdata',
          title: '大数据门户',
          ico: 'znlh',
        },
        {
          hostname: 'console',
          title: 'console后台',
          ico: 'znlh',
        },
        {
          hostname: 'workflow',
          title: '审批中转',
          ico: 'znlh',
        },
        {
          hostname: 'investor',
          title: '资方供应链平台',
          ico: 'znlh',
        },
      ],
    };
  },
  mounted() {
    const uiInfo = JSON.parse(localStorage.getItem("uiInfo")) || {};
    if (!isJSONString(uiInfo)) {
      // TODO 兜底ico和title
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.dictionary.length; i++) {
        if (window.location.hostname.toString().includes(this.dictionary[i].hostname)) {
          try {
            const _res = JSON.parse(localStorage.getItem('ui_fitment'));
            if(_res) {
              if(_res.homeTitle) {
                document.title = _res.homeTitle;
              }else {
                document.title = this.dictionary[i].title;
              }
              // if(_res.browserIco) {
              //   link.href = _res.browserIco;
              // }else {
              //   link.href = `./ico/${this.dictionary[i].ico}.ico`;
              // }

            }
          } catch (error) {
            document.title = this.dictionary[i].title;
            // link.href = `./ico/${this.dictionary[i].ico}.ico`;
          }


        }
      }
    }
  }
};

</script>
